/* eslint-disable no-var */
import React from 'react'
import { Modal, Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import './RenderModal.css'

interface RenderModalProps {
  onClose: () => void
  title: string
  className?: string
  additionalButtons?: JSX.Element[]
}
const RenderModal: React.FC<RenderModalProps> = ({
  onClose,
  title,
  className,
  additionalButtons,
  children
}) => {
  return (
    <Modal className={`custom-modal ${className}`} isOpen={true}>
      <ModalHeader className="modal-title" id="modalTitle">
        {title}
      </ModalHeader>
      <ModalBody>{children}</ModalBody>

      <ModalFooter className="modal-footer">
        {additionalButtons}
        <Button className="close-btn" onClick={(_) => onClose()}>
          <span className="glyphicons glyphicons-remove"></span>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}
export default RenderModal
